var IREP = IREP || {};

IREP.SWIC6Mobile = (function() {
    var defaultOptions = {
        mode: 'mobile'
    };

    var SWIC6Mobile = function(options) {
        var self = this;

        this.options = $.extend({}, defaultOptions, options);
        IREP.SWIC6.call(this, this.options);

        this.animateRings();
        $('#intro').show();
        this.setupOnce();

        this.delay(2000).then(function() {
            return self.hideMoon();
        }).then(function() {
            if (!self.options.firstVisit) {
                self.startHome();
            } else {
            return self.fadeTransition('.elevate', 1, 2000);
            }
        }).then(function() {
            return self.fadeTransition('.loading', 0, 2000);
        }).then(function() {
            $('.loading').hide();
            return self.fadeTransition('#intro p, #intro hr', 1, 2000);
        }).then(function() {
            $('#intro .home-button img').off().one('touchstart click', function(e) {
                self.startHome(); //needs to be tutorial in the future

                e.stopPropagation();
                e.preventDefault();
                return false;
            });
        });
    };

    SWIC6Mobile.prototype = Object.create(IREP.SWIC6.prototype);
    SWIC6Mobile.prototype.constructor = SWIC6Mobile;

    SWIC6Mobile.prototype.fadeTransition = function(element, opacity, duration) {
        var deferred = $.Deferred();
        $(element).css('opacity', opacity);

        this.delay(duration).then(function() {
            deferred.resolve();
        });

        return deferred.promise();
    };

    SWIC6Mobile.prototype.setupOnce = function() {
        var self = this;

        $("#home-leaderboard").on("click", function() { self.startLeaderboardNav(); });
        $("#home-garage").on("click", function () {
            self.startGarage();
        });
        $("#home-recons").on("click", function() { self.startRecon(); });
        $(".home-button").on("click", function() { self.startHome(); })

        /* Garage nav */
        this.garage = ko.observable({});
        ko.applyBindings(self, $('#mobile-garage')[0]);
    };

    /*************************
     * HOME
     *************************/

    SWIC6Mobile.prototype.startHome = function () {
        $('#topbar-svg, #bottombar-svg').show();
        this.switchPage('#home', 'home');
    };

    /*************************
     * LeaderboardNav
     *************************/

    SWIC6Mobile.prototype.startLeaderboardNav = function() {
        var self = this;
        this.switchPage('#leaderboardNav', 'leaderboardNav');

        this.trackNavigation('leaderboards');

        $('#leaderboardNav-svg [data-nav]').off().on('click', function() {
            var navItem = $(this).data('nav');
            switch (navItem) {
                case "profile":
                    self.trackLeaderboard('profile');
                    self.startProfile();
                    break;;
                case "dashboard":
                    self.trackLeaderboard('dashboard');
                    self.startDashboard();
                    break;
                case "leaderboard":
                    self.trackLeaderboard('leaderboard');
                    self.startLeaderboard();
                    break;
                case "token":
                    self.trackLeaderboard('token');
                    self.startToken();
                    break;
            }
        });
    };

    /************************
     * Individual Profile
     ************************/

    SWIC6Mobile.prototype.startProfile = function() {
        var self = this;
        $('#profile').off().one('touchstart click', 'svg', function(e) {
            self.startLeaderboardNav();

            e.stopPropagation();
            e.preventDefault();
            return false;
        });
        this.switchPage('#profile', 'profile').then(function() {
            $('#profile').children().hide();
            return $.when(self.getIndividualProfile(), self.showIndividualProfile(), self.showMoon());
        }).then(function(profile) {
            return $.when(profile, self.hideMoon());
        }).then(function(profile) {
            $('#profile').children().show();
        });
    };

    SWIC6Mobile.prototype.getIndividualProfile = function() {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    SWIC6Mobile.prototype.getProfile = function () {
        return IREP.callApi({ url: 'swic6/individualinfo' })
    };

    SWIC6Mobile.prototype.getIndividualLeaderboard = function () {
        return IREP.callApi({ url: 'swic6/individual' });
    };

    SWIC6Mobile.prototype.showIndividualProfile = function () {
        var self = this;
        $.when(this.getProfile(), this.getIndividualLeaderboard(), this.getIndividualProfile()).then(function (individual, individualinfo) {
            ko.applyBindings({ participants: individualinfo[0].leaderboard, profile: individual[0].info }, $('#profile')[0]);
        });
    };

    /************************
     * Store Dashboard
     ************************/

    SWIC6Mobile.prototype.startDashboard = function() {
        var self = this;
        $('#dashboard').off().one('touchstart click', 'svg', function(e) {
            self.startLeaderboardNav();

            e.stopPropagation();
            e.preventDefault();
            return false;
        });
        this.switchPage('#dashboard', 'dashboard').then(function() {
            $('#dashboard').children().hide();
            return $.when(self.getIndividualProfile(), self.showStoreDashboard(), self.showMoon());
        }).then(function(dashboard) {
            return $.when(dashboard, self.hideMoon());
        }).then(function(dashboard) {
            $('#dashboard').children().show();
        });
    };

    SWIC6Mobile.prototype.getStoreDashboard = function() {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    SWIC6Mobile.prototype.getManagerInfo = function () {
        return IREP.callApi({ url: 'swic6/managerinfo' });
    };

    SWIC6Mobile.prototype.getStoreProfile = function () {
        return IREP.callApi({ url: 'swic6/storeinfo' })
    };

    SWIC6Mobile.prototype.getStoreDashboard = function () {
        return IREP.callApi({ url: 'swic6/dashboard' });
    };   

    SWIC6Mobile.prototype.showStoreDashboard = function () {
        var self = this;
        $.when(this.getStoreProfile(), this.getManagerInfo(), this.getStoreDashboard(), this.getIndividualProfile()).then(function (storeProfile, managerInfo, storeDashboard) {
            ko.applyBindings({ storeProfile: storeProfile[0].info, manager: managerInfo[0].info, dashboard: storeDashboard[0].dashboard }, $('#dashboard')[0]);
        });
    };
    /***********************
     * Store Leaderboard
     **********************/

    SWIC6Mobile.prototype.startLeaderboard = function() {
        var self = this;

        $('#leaderboard').off().one('touchstart click', 'svg', function(e) {
            self.startLeaderboardNav();

            e.stopPropagation();
            e.preventDefault();
            return false;
        });
        this.switchPage('#leaderboard', 'leaderboard').then(function() {
            $('#leaderboard').children().hide();
            return $.when(self.getStoreLeaderboard(), self.showStoreLeaderboard(), self.showMoon());
        }).then(function(leaderboard) {
            return $.when(leaderboard, self.hideMoon());
        }).then(function(leaderboard) {
            $('#leaderboard').children().show();
        });
    };

    SWIC6Mobile.prototype.getStoreLeaderboard = function() {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    SWIC6Mobile.prototype.getStoreLeaderboard = function () {
        return IREP.callApi({ url: 'swic6/storeleaderboard' });
    };

    SWIC6Mobile.prototype.showStoreLeaderboard = function () {
        var self = this;
        $.when(this.getStoreProfile(), this.getStoreLeaderboard(), this.getManagerInfo(), this.getIndividualProfile()).then(function (storeProfile, storeLeaderboard, managerInfo) {
            ko.applyBindings({ storeProfile: storeProfile[0].info, manager: managerInfo[0].info, leaderboard: storeLeaderboard[0].leaderboard }, $('#leaderboard')[0]);
        });
    };

    /**********************
     * Token Redemption
     ***********************/

    SWIC6Mobile.prototype.startToken = function() {
        var self = this;
        $('#token').off().one('touchstart click', '#back-svg', function(e) {
            self.startLeaderboardNav();

            e.stopPropagation();
            e.preventDefault();
            return false;
        });
        this.switchPage('#token', 'token').then(function() {
            $('#token').hide();
            return $.when(self.setupTokens(), self.showMoon());
        }).then(function(token) {
            return $.when(token, self.hideMoon());
        }).then(function(token) {
            $('#token').show();
        });;
    };

    SWIC6Mobile.prototype.setupTokens = function () {
        var self = this;
        var deferred = $.Deferred();

        self.getProfile().done(function (d) {
            $("#weeklyDrawingEntries").html(d.info.drawingEntries);
            $("#availableTokens").html(d.info.tokensAvailable);

            if (d.info.tokensAvailable > 0)
            {
                $("#redeem-svg").off().one("touchstart", function () {
                    self.getTokenRedemption();
                });

            } else {
                $("#redeem-svg").hide();
            }
            
            deferred.resolve();
        });

        return deferred.promise();
    }

    SWIC6Mobile.prototype.getTokenRedemption = function() {
        var deferred = $.Deferred();
        var self = this;

        IREP.callApi({
            url: "swic6/redeemtoken"
        }).done(function (d) {
            if (d.info) {


                $("#weeklyDrawingEntries").html("+" + d.info.randomEntries)
                setTimeout(function () { $("#weeklyDrawingEntries").html(d.info.drawingEntries); }, 2000);
                $("#availableTokens").html(d.info.availableTokens);


                if(d.info.availableTokens > 0)
                {
                    $("#redeem-svg").off().one("touchstart", function () {
                        self.getTokenRedemption();
                    });
                }
            }

            deferred.resolve();
        });

        return deferred.promise();
    };

    /****************************
     * Recon
     ***********************/

    SWIC6Mobile.prototype.showReconBoard = function (recons) {
        var self = this;

        this.trackNavigation('recon');

        var utc = moment.utc();
        var revealImage = (utc.add(utc.hours() >= 20 ? 1 : 0, 'days').dayOfYear() % 9) + 1;
        $('#recon > img').attr('src', '/Content/Images/ASMO/2015SWIC/mobile/recon-hero-0' + revealImage + '.png');

        this.setupReconBoard(recons);
        $.when(this.hideMoon()).then(function () {
            $('#recon').children().show();

            $('#recon > img').css('left', $(document).width() / 2 - $('#recon > img').width() / 2);
            $('#board-svg [class*=slot]').off();
            $('#board-svg [class*=slot]:not([data-available=false])').off().one('touchstart click', function(e) {
                var quizType = $(this).data('quiztype');
                var reconUID = $(this).data('uid');

                self.startReconInstructions(quizType, reconUID);

                e.stopPropagation();
                e.preventDefault();
                return false;
            });
        });
    };

    SWIC6Mobile.prototype.setupReconBoard = function (recons) {
        $.each(recons, function (i, e) {
            var $element = $('.' + e.location);

            $element.attr('data-quiztype', e.type).data('quiztype', e.type);
            $element.attr('data-available', e.available).data('available', e.available);
            $element.attr('data-uid', e.uid).data('uid', e.uid);

            if (e.available === true) {
                $element.css('fill', '');
            } else {
                $element.css('fill', 'transparent');
            }
        });
    };

    /*********************************
                  Garage
    **********************************/


    SWIC6Mobile.prototype.startGarage = function () {
        var self = this;

        $('#home').hide();

        $.when(self.getGarageInfo(), self.showMoon()).then(function(data) {
            return $.when(data, self.hideMoon());
        }).then(function (data) {
            var garage = data[0];
            self.garage(garage);
            

            $('#topbar-svg, #bottombar-svg').hide();
            $('#pilot-status, #flight-summary, #parts-collection, #stash-collection').hide();

            self.switchPage('#mobile-garage', 'mobile-garage').then(function () {
                self.trackNavigation('garage');
            });
        });
    };

    SWIC6Mobile.prototype.getGarageInfo = function () {
        return IREP.callApi({ url: 'swic6/garage' });
    };

    SWIC6Mobile.prototype.openHomeTab = function() {
        this.startHome();
    };

    SWIC6Mobile.prototype.openPilotStatus = function() {
        var label = 'pilot-status';
        if (!$('#' + label).is(':visible')) {
            $('#flight-summary, #parts-collection, #stash-collection').hide();
            this.trackGarage(label);
            $('#' + label).show();
        }
    };

    SWIC6Mobile.prototype.openFlightSummary = function() {
        var label = 'flight-summary';
        if (!$('#' + label).is(':visible')) {
            $('#pilot-status, #parts-collection, #stash-collection').hide();
            this.trackGarage(label);
            $('#' + label).show();
        }
    };

    SWIC6Mobile.prototype.openPartsCollection = function() {
        var label = 'parts-collection';
        if (!$('#' + label).is(':visible')) {
            $('#pilot-status, #flight-summary, #stash-collection').hide();
            this.trackGarage(label);
            $('#' + label).show();
        }
    };

    SWIC6Mobile.prototype.openStashCollection = function() {
        var label = 'stash-collection';
        if (!$('#' + label).is(':visible')) {
            $('#pilot-status, #flight-summary, #parts-collection').hide();
            this.trackGarage(label);
            $('#' + label).show();
        }
    };


    return SWIC6Mobile;
}());